import { render, staticRenderFns } from "./BTextarea.vue?vue&type=template&id=6be733d4"
import script from "./BTextarea.vue?vue&type=script&lang=js"
export * from "./BTextarea.vue?vue&type=script&lang=js"
import style0 from "./BTextarea.vue?vue&type=style&index=0&id=6be733d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports